import { create } from "zustand";
import { closeOtherModals, registerModalStore } from "./modal-registry";

/** Key this store is known by in the modal registry. */
const MODAL_NAME = "save-collection-colours";

/**
 * The "Save colours" modal: pick which of an influencer's colours to copy into your own palette.
 */
export const useSaveCollectionColoursModalStore = create((set) => ({
  isModalOpen: false,
  formUrl: null,
  collectionId: null,

  openModal: ({ formUrl, collectionId }) => {
    closeOtherModals(MODAL_NAME);

    set({ isModalOpen: true, formUrl, collectionId });
  },
  closeModal: () => set({ isModalOpen: false, formUrl: null, collectionId: null }),
  updateIsModalOpen: (isModalOpen) => set({ isModalOpen }),
}));

registerModalStore(MODAL_NAME, useSaveCollectionColoursModalStore);
